/* __next_internal_client_entry_do_not_use__ MasterCard auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { createSVGIcon } from "../util";
// https://docs.adyen.com/online-payments/api-only/downloading-logos
var SquareLogo = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M3 0.25H37C38.5188 0.25 39.75 1.48122 39.75 3V37C39.75 38.5188 38.5188 39.75 37 39.75H3C1.48122 39.75 0.25 38.5188 0.25 37V3C0.25 1.48122 1.48122 0.25 3 0.25Z",
            fill: "white",
            stroke: "#AAAAAA",
            strokeWidth: "0.5"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M16.1328 26.3088H23.8728V13.7188H16.1328V26.2988V26.3088Z",
            fill: "#F06022"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M16.9307 20.0176C16.9271 18.8042 17.2019 17.6061 17.7342 16.5156C18.2664 15.4251 19.0418 14.4713 20.0007 13.7276C18.4548 12.5109 16.5156 11.9048 14.5519 12.0247C12.5883 12.1445 10.7372 12.9819 9.3507 14.3776C8.60811 15.1172 8.01888 15.9962 7.61683 16.964C7.21478 17.9319 7.00781 18.9696 7.00781 20.0176C7.00781 21.0657 7.21478 22.1034 7.61683 23.0713C8.01888 24.0391 8.60811 24.9181 9.3507 25.6576C10.7372 27.0534 12.5883 27.8908 14.5519 28.0106C16.5156 28.1305 18.4548 27.5244 20.0007 26.3076C19.0469 25.5594 18.2751 24.6047 17.7433 23.5152C17.2116 22.4258 16.9337 21.2299 16.9307 20.0176",
            fill: "#EA1D25"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M33 20.0167C33 22.1367 32.16 24.1667 30.66 25.6667C29.263 27.048 27.4115 27.8745 25.4504 27.9922C23.4893 28.11 21.5523 27.5109 20 26.3067C20.9522 25.557 21.7228 24.6019 22.2544 23.5128C22.786 22.4237 23.0648 21.2286 23.07 20.0167C23.0714 18.8036 22.7955 17.6063 22.2634 16.5162C21.7314 15.426 20.9572 14.4719 20 13.7267C21.5454 12.5059 23.4861 11.8964 25.452 12.0144C27.4179 12.1325 29.2717 12.9697 30.66 14.3667C31.4046 15.1067 31.9949 15.9872 32.3965 16.9571C32.7982 17.9269 33.0034 18.9669 33 20.0167",
            fill: "#F79D1D"
        })
    ]
}), "MasterCardSquare", {
    viewBox: "0 0 40 40",
    titleAccess: "Square MasterCard Icon",
    fill: "none"
});
var Logo = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M3 0.25H37C38.5188 0.25 39.75 1.48122 39.75 3V23C39.75 24.5188 38.5188 25.75 37 25.75H3C1.48122 25.75 0.25 24.5188 0.25 23V3C0.25 1.48122 1.48122 0.25 3 0.25Z",
            fill: "white",
            stroke: "#AAAAAA",
            strokeWidth: "0.5"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M16.1289 19.2902H23.8689V6.7002H16.1289V19.2802V19.2902Z",
            fill: "#F06022"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M16.9307 13.0001C16.9271 11.7866 17.2019 10.5885 17.7342 9.49804C18.2664 8.40754 19.0418 7.45374 20.0007 6.71007C18.4548 5.49333 16.5156 4.88725 14.5519 5.00709C12.5883 5.12694 10.7372 5.96436 9.3507 7.36007C8.60811 8.09964 8.01888 8.97858 7.61683 9.94643C7.21478 10.9143 7.00781 11.952 7.00781 13.0001C7.00781 14.0481 7.21478 15.0858 7.61683 16.0537C8.01888 17.0216 8.60811 17.9005 9.3507 18.6401C10.7372 20.0358 12.5883 20.8732 14.5519 20.993C16.5156 21.1129 18.4548 20.5068 20.0007 19.2901C19.0469 18.5418 18.2751 17.5871 17.7433 16.4976C17.2116 15.4082 16.9337 14.2124 16.9307 13.0001Z",
            fill: "#EA1D25"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M33 13.0001C33 15.1201 32.16 17.1501 30.66 18.6501C29.263 20.0314 27.4115 20.8579 25.4504 20.9756C23.4893 21.0934 21.5523 20.4943 20 19.2901C20.9522 18.5404 21.7228 17.5853 22.2544 16.4962C22.786 15.4071 23.0648 14.212 23.07 13.0001C23.0714 11.787 22.7955 10.5897 22.2634 9.49956C21.7314 8.40942 20.9572 7.4553 20 6.71009C21.5454 5.48927 23.4861 4.87979 25.452 4.99782C27.4179 5.11585 29.2717 5.95314 30.66 7.35009C31.4046 8.09009 31.9949 8.97057 32.3965 9.94045C32.7982 10.9103 33.0033 11.9503 33 13.0001Z",
            fill: "#F79D1D"
        }),
        /*#__PURE__*/ _jsx("rect", {
            x: "0.25",
            y: "0.25",
            width: "39.5",
            height: "25.5",
            rx: "2.75",
            stroke: "#AAAAAA",
            strokeWidth: "0.5"
        })
    ]
}), "MasterCard", {
    viewBox: "0 0 40 26",
    titleAccess: "MasterCard Icon",
    fill: "none"
});
export var MasterCard = /*#__PURE__*/ React.memo(function(_param) {
    var square = _param.square, ref = _param.ref, props = _object_without_properties(_param, [
        "square",
        "ref"
    ]);
    var Icon = square ? SquareLogo : Logo;
    return /*#__PURE__*/ _jsx(Icon, _object_spread({
        ref: ref
    }, props));
});
